var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row form-group text-area-row" }, [
    _vm.title
      ? _c(
          "span",
          {
            class: [
              _vm.labelClass ? _vm.labelClass : "col-xs-12 col-sm-5",
              "col-form-label",
              _vm.bold ? "bold" : ""
            ]
          },
          [
            _vm.doNotUseResources
              ? _c("span", [_vm._v(_vm._s(_vm.title))])
              : _c("span", [_vm._v(_vm._s(_vm.$t(_vm.title)))])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [
          _vm.valueClass ? _vm.valueClass : "col-xs-12 col-sm-7",
          "col-form-label"
        ]
      },
      [
        _vm.value
          ? _c(
              "span",
              {
                class: {
                  "float-right": _vm.alignRight,
                  unstyled: _vm.htmlStyleNone
                }
              },
              [
                _vm.formatNumber
                  ? _c("span", { staticStyle: { "white-space": "pre-wrap" } }, [
                      _vm._v(_vm._s(_vm._f("formatNumber")(_vm.value)))
                    ])
                  : _vm.formatDate
                  ? _c("span", { staticStyle: { "white-space": "pre-wrap" } }, [
                      _vm._v(
                        _vm._s(_vm._f("formatDate")(_vm.value, _vm.noTime))
                      )
                    ])
                  : _vm.htmlContent
                  ? _c("span", { domProps: { innerHTML: _vm._s(_vm.value) } })
                  : _c("span", {
                      staticClass: "preformatted",
                      domProps: { innerHTML: _vm._s(_vm.value) }
                    }),
                _vm._v(" "),
                _vm.sign ? _c("span", [_vm._v(_vm._s(_vm.sign))]) : _vm._e()
              ]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }